import config from './config';
import {getCookieConsent, hasTrackingConsent, COOKIE_CONSENT_EVENT} from './cookieConsent';

let loaded = false;

function loadTagManager() {
    if (loaded || !hasTrackingConsent() || ![config.domain, `www.${config.domain}`].includes(window.location.hostname)) return;
    loaded = true;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({'gtm.start': Date.now(), event: 'gtm.js'});
    const script = document.createElement('script');
    script.id = 'ylp-google-tag-manager';
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${config.gtmId}`;
    document.head.appendChild(script);
}

function clearTrackingCookies() {
    const domains = window.location.hostname.split('.');
    for (const entry of document.cookie.split(';')) {
        const name = entry.trim().split('=')[0];
        if (!/^(_ga(?:_|$)|_gid$|_gat|_gcl_|_fbp$|_fbc$|_ym_|_pin_|sib_cuid$|yabs-sid$|ymex$|yuidss$|yuidlt$|yandexuid$|yp$)/.test(name)) continue;
        const expired = `${name}=; Max-Age=0; path=/`;
        document.cookie = expired;
        for (let i = 0; i < domains.length - 1; i++) {
            const domain = domains.slice(i).join('.');
            document.cookie = `${expired}; domain=${domain}`;
            document.cookie = `${expired}; domain=.${domain}`;
        }
    }
}

export function startConsentTracking() {
    let previous = getCookieConsent();
    if (!hasTrackingConsent(previous)) clearTrackingCookies();
    loadTagManager();
    const handleChange = ({detail: next}) => {
        const revoked = hasTrackingConsent(previous) && !hasTrackingConsent(next);
        previous = next;
        if (revoked) {
            if (typeof window.fbq === 'function') window.fbq('consent', 'revoke');
            clearTrackingCookies();
            window.location.reload();
        } else {
            loadTagManager();
        }
    };
    window.addEventListener(COOKIE_CONSENT_EVENT, handleChange);
    return () => window.removeEventListener(COOKIE_CONSENT_EVENT, handleChange);
}
